module.exports = __webpack_public_path__ + "img/bim (3).0656b1fe.png";